import config from "../../config/config.json";
import { getHeaders } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../APIHelpers/Responses";

export const itemServices = {
  addNewItem,
  updatedItem,
  updateStatusItem,
  deleteItem,
  getItemList,
  getMyItemList,
  getAllItemList,
  getUniqueItemList,
  getSingleItem,
};

// Add New Item
async function addNewItem(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewItem`,
    headersWithAuth("POST", userData, getHeaders(auth))
  );
  const result = await response.json();
      const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Item
async function updatedItem(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedItem`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
    const data = decryptResponse(result);
  if (!userData?.bookmarkType) {
    handleResponse(data)
  }
  return data;
}

// Soft Delete and Restore Item
async function updateStatusItem(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStatusItem`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
    const data = decryptResponse(result);
  if (!userData?.bookmarkType || data?.statusCode === 401 || data?.statusCode === 423) {
    handleResponse(data)
  }
  return data;
}

// Delete Item
async function deleteItem(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteItem`,
    headersWithAuth("DELETE", userData, getHeaders(auth))
  );
  const result = await response.json();
    const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Item
async function getItemList(auth, status, groupId, metaTitle, searchData, categoryId, page, length) {
  try {
    const signal = cancelPreviousRequest("getItemList");
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getItemList/${status}/${groupId}?metaTitle=${metaTitle}&search=${searchData || ""}&categoryId=${categoryId || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getItemList/${status}/${groupId}?metaTitle=${metaTitle}&search=${searchData || ""}&categoryId=${categoryId || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401 || data?.statusCode === 423){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get All Item
async function getAllItemList(auth) {
  try {
    const signal = cancelPreviousRequest("getAllItemList");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getAllItemList`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401 || data?.statusCode === 423){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get My Item
async function getMyItemList(auth) {
  try {
    const signal = cancelPreviousRequest("getMyItemList");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getMyItemList`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401 || data?.statusCode === 423){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Unique Item List
async function getUniqueItemList(auth, status, groupId, categoryId, searchData, page, length) {
  try {
    const signal = cancelPreviousRequest("getUniqueItemList");
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getUniqueItemList/${status}/${groupId}?search=${searchData || ""}&categoryId=${categoryId || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getUniqueItemList/${status}/${groupId}?search=${searchData || ""}&categoryId=${categoryId || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401 || data?.statusCode === 423){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Item Details
async function getSingleItem(auth, itemId) {
  try {
    const signal = cancelPreviousRequest("getSingleItem");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleItem/${itemId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401 || data?.statusCode === 423){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}